import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./components/App";

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root not found");
const root = createRoot(container);
root.render(
	<Router>
		<App />
	</Router>
);
